import { Members } from '@factorin/domain';

import { get, post, put, withUrl, Request, ItemRequest } from '../rest';


type FillBalanceRequest = ItemRequest & { amount: number };

const membersPart = withUrl('members');

export const members = {
    list: get<void, Members.ExpandMember[]>(
        () => membersPart(),
    ),
    item: get<ItemRequest, Members.ExpandMember>(
        ({ id }) => membersPart({
            path: `${id}`,
        }),
    ),

    create: post<Request.Body, void>(
        ({ body }) => membersPart({ body }),
    ),
    update: put<Request.Body, void>(
        ({ body }) => membersPart({ body }),
    ),

    roles: get<void, string[]>(
        () => membersPart({ path: 'roles' }),
    ),

    fillBalance: post<FillBalanceRequest, void>(
        ({ id, amount }) => membersPart({
            path: `${id}/fillBalance`,
            body: { amount },
        }),
    ),

    updateBox: put<ItemRequest, void>(
        ({ id }) => membersPart({
            path: `${id}/updatebox`,
        }),
    ),
};
